import {
  Button,
  ButtonsWrapper,
  Form,
  Modal,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetCompanyPositions } from 'src/hooks/company-positions/get-company-positions.hook';
import { useUpdateMemberPosition } from 'src/hooks/members/update-member-position.hook';

const EditUserPosition = ({
  onClose,
  selectedUser,
}: {
  onClose: () => void;
  selectedUser?: any;
}) => {
  const { t } = useTranslation(['common', 'settings']);
  const currentCompanyId = useGetCurrentCompanyId();
  const { companyPositions } = useGetCompanyPositions({
    companyId: currentCompanyId,
    deleted: false,
  });
  const { updateMemberPosition } = useUpdateMemberPosition({ onSuccess: onClose });

  const onFinish = ({ positionId }: any) => {
    updateMemberPosition({
      variables: {
        positionId,
        memberId: selectedUser._id,
      },
    });
  };

  return (
    <Modal
      isOpened
      onClose={onClose}
      title={t('settings:userManagementSettings.labels.editUserPosition')}
    >
      <Form
        layout="vertical"
        initialValues={{ positionId: selectedUser.companyPosition._id }}
        onFinish={onFinish}
      >
        <Form.Item
          name="positionId"
          label={t('settings:userManagementSettings.labels.userPosition')}
          rules={[{ required: true }]}
        >
          <SelectInput>
            {companyPositions.map(({ _id: positionId, name }: any) => (
              <SelectInput.Option value={positionId} key={positionId}>
                {name}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>
        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default EditUserPosition;
